export function calculateFundsDistributed({
  totalDistributed,
  totalAvailable,
}: {
  totalDistributed: number
  totalAvailable: number
}) {
  if (totalAvailable === 0) {
    return 0
  }

  const total = (totalDistributed / totalAvailable) * 100

  return parseFloat(total.toFixed(1))
}
